import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Tick } from '../icon';
import { Spacer } from '../spacer';
import { getResponsiveType } from '../../utils';

// Interface

export interface TickListProps {
  items?: TickListItemProps[];
}

export interface TickListItemProps {
  label?: string;
}

// Styles

export const StyledItem = styled.li`
  ${({ theme: { space } }) => css`
    display: flex;
    gap: ${space.xxxSmall};
    ${getResponsiveType('bodyMedium')}
  `};
`;

export const StyledTick = styled(Tick)`
  ${({ theme: { colors } }) => css`
    color: ${colors.brandTwo100};
    margin-top: -2px; // Adjust for internal space in tick
  `};
`;

// JSX

export const TickList: FC<TickListProps> = ({ items = [] }) => {
  if (!items || items.length <= 0) {
    return null;
  }

  return (
    <Spacer as="ul" spacing="xSmall">
      {items?.map(
        (item, index) =>
          item && (
            <StyledItem key={index}>
              <StyledTick size="small" /> {item}
            </StyledItem>
          )
      )}
    </Spacer>
  );
};

export default TickList;
